/**
 * Validates a location ref used as a URL path segment and localStorage key.
 * Allows only alphanumerics, hyphens, and underscores — blocks path traversal and injection chars.
 */
export function isValidRef(value: unknown): value is string {
	return typeof value === 'string' && /^[a-zA-Z0-9_-]{1,64}$/.test(value)
}
